import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Polyline, Popup, useMapEvents, GeoJSON } from "react-leaflet";
import { divIcon, DomEvent, icon } from "leaflet";
import hash from "object-hash";
import { lineString } from "@turf/helpers";
import bezierSpline from "@turf/bezier-spline";

import { Box, Button, Card, Stack, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changePointPosition, removePoint } from "Redux/pointsSlice";
import DestinationIcon from "Assets/Images/Survey/destination-icon.svg";
import SourceIcon from "Assets/Images/Survey/source-icon.svg";
import { LOGO } from "Configs/core";
import {
  changeSelectLocMode,
  setSelectedLoc,
  changeShowAddSurvayModal,
  changeShowAddStationModal,
  setStationLoc,
} from "Redux/mapSlice";
import { changeModal } from "Redux/modalSlice";

const ICON_SIZE = 65;

export default function AddStation() {
  const dispatch = useAppDispatch();
  const { selectLocMode, center, selectedLoc, selectLocFor } = useAppSelector((state) => state.map);

  const handleSelect = () => {
    if (selectLocMode === 1) {
      dispatch(changeSelectLocMode(2));
      dispatch(setStationLoc(center));
    }
    if (selectLocMode === 2) {
      dispatch(changeSelectLocMode(0));
      dispatch(changeShowAddStationModal(true));
      // const Loc = [...selectedLoc];
      // Loc[1] = center;
      // dispatch(setStationLoc(center));
    }
    // if (selectLocMode === "end") {
    //   if (selectLocFor === "add-station") {
    //     // dispatch(changeModal({ status: "add-station", data: { lat: 30, lng: 50 } }));
    //     dispatch(changeShowAddStationModal(true));
    //   }

    //   dispatch(changeSelectLocMode(""));
    // }
  };

  const handlePrev = () => {
    if (selectLocMode === 2) {
      dispatch(changeSelectLocMode(1));
    }
    // if (selectLocMode === "source") {
    //   dispatch(changeSelectLocMode("destination"));
    //   const Loc = [...selectedLoc];
    //   Loc[0] = center;
    //   dispatch(setSelectedLoc(Loc));
    // }
  };

  const mode = () => {
    if (selectLocMode === 1) {
      return "انتخاب نقطه";
    }
    if (selectLocMode === 2) {
      return "ادامه";
    }
  };

  return (
    <Stack sx={{ flexGrow: 1, justifyContent: "center" }} direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={1}>
        <Button variant="white" size="large" style={{ width: "200px" }} onClick={handleSelect}>
          {mode()}
        </Button>
        <Button variant="white" size="large" style={{ width: "200px" }} disabled={selectLocMode === 1} onClick={handlePrev}>
          قبلی
        </Button>
      </Stack>
    </Stack>
  );
}
